import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../styles/Auth.css';

/**
 * AdminRoute ,  protects the /admin route.
 *
 * Requirements to pass through:
 *   1. Session must be authenticated (same as ProtectedRoute)
 *   2. profiles.role must equal 'admin' (server-enforced via RLS is_admin())
 *
 * Shows the same loading skeleton as ProtectedRoute while checking session.
 * Redirects non-admins to /dashboard (not /login) ,  they are logged in, just not admin.
 */
export default function AdminRoute({ children }) {
  const { isAuthenticated, loading, sessionChecked, profile } = useAuth();

  // Still resolving session / profile ,  show skeleton to prevent flash
  if (loading || !sessionChecked) {
    return (
      <div className="auth-skeleton">
        <div className="auth-skeleton-card">
          <div className="auth-skeleton-line medium" />
          <div className="auth-skeleton-line short" />
          <div className="auth-skeleton-line tall" />
          <div className="auth-skeleton-line" />
          <div className="auth-skeleton-line tall" />
        </div>
      </div>
    );
  }

  // Not authenticated at all → send to login
  if (!isAuthenticated) {
    return <Navigate to="/login?redirect=/admin" replace />;
  }

  // Profile not yet loaded ,  wait (loading covers this, but guard against null)
  if (!profile) {
    return (
      <div className="auth-skeleton">
        <div className="auth-skeleton-card">
          <div className="auth-skeleton-line medium" />
          <div className="auth-skeleton-line short" />
          <div className="auth-skeleton-line tall" />
        </div>
      </div>
    );
  }

  // Authenticated but not an admin → send to dashboard
  if (profile.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
